import { render, staticRenderFns } from "./Detail-Service.vue?vue&type=template&id=5b4a5448&"
import script from "./Detail-Service.vue?vue&type=script&lang=js&"
export * from "./Detail-Service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports